export class ZollerMode {
  constructor(
    public hash?: string,
    public name?: string
  ) { }

  clone() {
    return new ZollerMode (
      this.hash,
      this.name
    );
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/zoller-mode.ts